import { useEffect, useRef, useState } from "preact/hooks"
import { useFormContext } from "../../context/form-context"
import { countTo } from "../../util/count-to"

const watchCounterIntersection = (counterRef, counter) => {
  const countCallback = (entries) => {
    entries.forEach((entry) => {
      const el = entry.target
      if (entry.intersectionRatio > 0 && el.dataset.counted !== "1") {
        el.dataset.counted = "1"

        countTo(counterRef.current, counter, 3000)
      }
    })
  }

  const instance = new IntersectionObserver(countCallback)
  instance.observe(counterRef.current)
}

export const Counter = (props) => {
  const { ep, inFormValues } = useFormContext()
  const [counter, setCounter] = useState("")
  const counterRef = useRef()

  useEffect(() => {
    counter === "" &&
      ep
        .getData(`city=${inFormValues({ name: "city" })?.value}&counter`)
        .then((epData) => {
          setCounter(Number(epData.counter))
        })
  })

  useEffect(() => {
    counter !== "" && watchCounterIntersection(counterRef, counter)
  }, [counter, counterRef])

  const replacedBody = props.body.replace("###", `${counter - 1}`)

  return (
    <div class={`counter ${props.layout}`}>
      {props.layout === "final"
        ? // biome-ignore lint/security: it's not dangerous in this case
          <span dangerouslySetInnerHTML={{ __html: replacedBody }} />
        : null}
      <div ref={counterRef}>{counter}</div>
      {props.layout === "big"
        ? // biome-ignore lint/security: it's not dangerous in this case
          <span dangerouslySetInnerHTML={{ __html: props.body }} />
        : null}
    </div>
  )
}
